import { render, staticRenderFns } from "./Funmi.vue?vue&type=template&id=d8fce6aa&scoped=true&"
import script from "./Funmi.vue?vue&type=script&lang=js&"
export * from "./Funmi.vue?vue&type=script&lang=js&"
import style0 from "./Funmi.vue?vue&type=style&index=0&id=d8fce6aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fce6aa",
  null
  
)

export default component.exports